<template>
  <div class="uk-card">
    <form @submit.prevent="addLog" class="uk-grid-small" uk-grid>
      <div class="uk-margin uk-width-1-1">
        <label class="uk-form-label" for="form-stacked-text"> Fecha </label>
        <div class="uk-form-controls uk-position-relative">
          <datepicker
            class="uk-input"
            placeholder="Seleccione una fecha"
            v-model="date"
            required
            :upper-limit="limit_to"
          />
        </div>
      </div>
      <div class="uk-margin uk-width-1-1">
        <label class="uk-form-label" for="form-stacked-text">
          Descripción
        </label>
        <div class="uk-form-controls">
          <textarea
            class="uk-textarea"
            rows="3"
            limit="140"
            v-model="logDescription"
            required
          ></textarea>
        </div>
      </div>
      <div class="uk-margin uk-width-1-1">
        <label class="uk-form-label" for="form-stacked-text"> Cliente: </label>
        <div class="uk-form-controls">
          <select class="uk-select" v-model="client" @change="clientChanged">
            <option disabled value="">Seleccione un cliente</option>
            <option v-for="(client, index) in listClients" :value="client" :key="index" >
              {{ client }}
            </option>
          </select><br/><br/>
          <label class="uk-form-label" for="form-stacked-text">Agregar nuevo cliente:</label>
          <input
            class="uk-input"
            id="form-stacked-text"
            type="text"
            v-model="newClient"
            @change="newClientChanged"
          />
        </div>
      </div>
      <div class="uk-margin uk-width-1-2@s">
        <label class="uk-form-label" for="form-stacked-text"> Horas </label>
        <input
          class="uk-input"
          id="form-stacked-text"
          type="number"
          min="0"
          max="12"
          required
          v-model="hours"
        />
      </div>
      <div class="uk-margin uk-width-1-2@s">
        <label class="uk-form-label" for="form-stacked-text"> Minutos </label>
        <input
          class="uk-input"
          id="form-stacked-text"
          type="number"
          step="15"
          min="0"
          max="45"
          required
          v-model="minutes"
        />
      </div>
      <div class="uk-margin uk-width-1-1 uk-text-center">
        <button class="uk-button uk-background-gradient-primary uk-border-rounded uk-width-1-1">Agregar</button>
      </div>
    </form>
  </div>
</template>
<script>
import Datepicker from 'vue3-datepicker'
import { getDatabase, ref, push, set, onValue, query, orderByChild, orderByValue } from "firebase/database";
import { getAuth } from "firebase/auth";


export default {
  name: "FormLog",
  components: {
    Datepicker
  },
  data() {
    return {
      logDescription: "",
      client: "",
      listClients: [],
      newClient: "",
      date: new Date(),
      hours: 1,
      minutes: 0,
      limit_to: new Date(),
      newListClients: [],
    };
  },
  methods: {
    addLog() {
      const db = getDatabase();
      const postLogRef = ref(db, "logs");
      const clientsRef = ref(db, "clients");
      const newLogRef = push(postLogRef);
      const newClientRef = push(clientsRef);

      // User Data
      const auth = getAuth();
      const userName = auth.currentUser.displayName;
      const userId = auth.currentUser.uid;
      
      // Convert date to timestamp
      const date = this.date;
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      const dayZero = day < 10 ? "0" + day : day;
      const monthZero = month < 10 ? "0" + month : month;
      let dateToString = "";

      // if( day >! 10 ){
      //   dateToString = `${year}-${month}-0${day}`;
      // }else{
      //   dateToString = `${year}-${month}-${day}`;
      // }

      dateToString = `${year}-${monthZero}-${dayZero}`;

      set(newLogRef, {
        logDescription: this.logDescription,
        client: this.newClient != '' ? this.newClient : this.client,
        date: dateToString,
        hours: this.hours,
        minutes: this.minutes,
        user: userName,
        uid: userId,
      }).then(() => {

        UIkit.notification({
            message: '<span uk-icon=\'icon: check\'></span> Registro Agregado',
            status: 'success',
            pos: 'top-center',
            timeout: 3000
        });

        this.logDescription = "";
        this.client = "";
        this.newClient = "";
        this.hours = 1;
        this.minutes = 0;
        // set localStorage to empty string logDescription
        localStorage.setItem("logDescription", "");
        //alert("Log Agregado");

      });

      if(this.newClient != '') {
        set(newClientRef, {
          name: this.newClient,
        }).then(() => {
          console.log("Cliente Agregado");
        });
      }
      
    },
    clientChanged() {
        this.newClient = ""
    },
    newClientChanged() {
        this.client = ""
    },
  },
  computed: {
    // convertDateToString() {
    //   const date = this.date;
    //   const day = date.getDate();
    //   const month = date.getMonth() + 1;
    //   const year = date.getFullYear();
    //   let dateToString = "";

    //   const dayZero = day < 10 ? "0" + day : day;
    //   console.log(dayZero);

    //   console.log(day, month, year);

    //   dateToString = `${year}-${month}-${dayZero}`;

    //   // if( day > 9 ){
    //   //   dateToString = `${year}-${month}-${day}`;
    //   //   console.log(dateToString);

    //   // }else{
    //   //   dateToString = year + '-' + month + '-0' + day;
    //   //   console.log(dateToString);
    //   // }

    //   return dateToString;
    // },

    async getClients() {
      const db = getDatabase();
      const refDb = ref(db, "clients");
      const clientsRef = query(refDb);
      
      onValue(clientsRef, (snapshot) => {
        const clients = snapshot.val();

        for(let client in clients) {
          this.newListClients.push(clients[client].name);
        }

        this.listClients = this.newListClients.sort();

      });
    },
    
  },
  watch: {
    logDescription() {
      localStorage.setItem("logDescription", this.logDescription);
    },
  },
  mounted() {
    if (localStorage.logDescription) {
      this.logDescription = localStorage.getItem("logDescription");
    }else{
      localStorage.setItem("logDescription", this.logDescription);
    }

    //get clients.
    this.getClients;
  },
};
</script>
